/**
 * @file index.jsx
 * @author Fernando Ruano
 * @description Nutritional card
 */

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { groupBy, isEmpty } from 'lodash';

// Assets
import { ReactComponent as WeightPreHigh } from '@nephro/assets/IMC_Preobesidad_white.svg';
import { ReactComponent as WeightLow } from '@nephro/assets/IMC_Delgadez_white.svg';
import { ReactComponent as WeightNormal } from '@nephro/assets/IMC_Normal_white.svg';
import { ReactComponent as WeightHigh } from '@nephro/assets/IMC_Obesidad_white.svg';

// Helpers
import { onGetWeightType } from '@nephro/commons/helpers/utils';
import { NUTRITIONAL_INDICATOR } from '@nephro/pages/Indicators/helpers/constants';

// Hooks
import usePatientIndicators from '@nephro/pages/Indicators/helpers/usePatientIndicators';

// Components
import DashboardPatientCard from '../dashboardPatientCard';

const NutritionalCard = () => {
  const { t: translate } = useTranslation();
  const [data, setData] = useState(null);
  const nutritionalData = usePatientIndicators(NUTRITIONAL_INDICATOR);

  const nutritionalMenuStatus = [
    {
      status: 'low',
      subTitle: 'Delgadez',
      icon: <WeightLow />
    },
    {
      status: 'normal',
      subTitle: 'Normal',
      icon: <WeightNormal />
    },
    {
      status: 'preHigh',
      subTitle: 'Preobesidad',
      icon: <WeightPreHigh />
    },
    {
      status: 'high',
      subTitle: 'Obesidad',
      icon: <WeightHigh />
    }
  ];

  const onGetWeightItem = (val) => {
    const [weightItm] = nutritionalMenuStatus.filter(
      (itm) => onGetWeightType(val) === itm.status
    );
    return weightItm;
  };

  const title = translate('dashboardPatient.nutritionalTitle');

  useEffect(() => {
    if (nutritionalData && !isEmpty(nutritionalData)) {
      const groupByUnity = groupBy(nutritionalData, 'unidad');
      const imcItem = onGetWeightItem(groupByUnity['kg/m²'][0]?.valor);

      const footer = { text: imcItem?.subTitle };
      const mainIcon = imcItem?.icon;
      const componentData = {
        title,
        link: 'patient-nutritional',
        mainIcon,
        footer,
        background: 'bg-cardCyan',
        textStyles: 'text-green-900',
        titleStyles: 'text-green-900'
      };
      setData(componentData);
    }
  }, [title, nutritionalData]);

  return <DashboardPatientCard data={data} />;
};

export default NutritionalCard;
